var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SendTable',{attrs:{"opt-type":"20,30"}})
}
var staticRenderFns = []

export { render, staticRenderFns }